let pkgName = ''
let appid = ''
let appInfo = ''
let cdnConfigUrl = '' // cdn配置文件地址
let ossConfigUrl = '' // oss配置文件地址
let app_version = '1.1.4' //应用版本
let env = process.env.NODE_ENV // 应用环境
const appList = [{
    appid: 'wx98869fd58b1a0633',
    name: '大风h5',
    apiHost: 'http://test.kuaikanju.go.yunxiacn.com',
    commonHost: 'https://test.ad-attribution-query.yunxiacn.com',
    webHost: process.env.VUE_APP_HOST,
    pkgName: 'com.wx.kuaikanju',
    pkgGroup: 'com.wx.kuaikanju'
  },
  {
    appid: 'wx3622777fde759e7a',
    name: '快看剧',
    apiHost: 'https://kuaikanju.go.muchcloud.com:18443',
    commonHost: 'https://test.ad-attribution-query.yunxiacn.com',
    webHost: process.env.VUE_APP_HOST,
    pkgName: 'com.wx.kuaikanju',
    pkgGroup: 'com.wx.kuaikanju'
  },
]
console.log('NODE_ENV', process.env.NODE_ENV, process.env)
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'preprod') {
  appid = 'wx3622777fde759e7a'
  env = 'production'
} else {
  appid = 'wx98869fd58b1a0633'
  env = 'development'
}

const currentApp = appList.find(e => e.appid == appid)
pkgName = currentApp.pkgName
cdnConfigUrl = env !== 'production' ? `https://test.operation.platfrom.yunxiacn.com/cloud/config/new/${currentApp.pkgGroup}/config.json` : `https://fruitsoss.yunyihudong.com/cloud/config/new/${currentApp.pkgGroup}/config.json`
ossConfigUrl = env !== 'production' ? `https://test.operation.platfrom.yunxiacn.com/cloud/config/new/${currentApp.pkgGroup}/config.json` : `https://fruitsoss.yunyihudong.com/cloud/config/new/${currentApp.pkgGroup}/config.json`
console.log('currentApp')
export default {
  web_name: '网站名称',
  apiHost: currentApp.apiHost,
  commonHost: currentApp.commonHost,
  cdnConfigUrl,
  ossConfigUrl,
  debug: true,
  version: '1.0.1',
  pkgName,
  env,
  currentApp,
  app_version,
  appInfo
}
